import {
  BasicInformationSection,
  BiographySection,
  CaresAboutSection,
  ChannelsSection,
  DemographicsSection,
  GainsSection,
  GwiLinkSection,
  PainsSection,
} from '../sections';

export function PersonaInformationTab() {
  return (
    <div className="flex flex-col gap-12">
      <BasicInformationSection />
      <BiographySection />
      <DemographicsSection />
      <CaresAboutSection />
      <ChannelsSection />
      <PainsSection />
      <GainsSection />
      <GwiLinkSection />
    </div>
  );
}
